import { useNavigate } from "react-router-dom";
import { Navbar } from "../components";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen max-w-screen bg-gradient-to-br from-blue-50 via-white to-orange-50">
      <Navbar />

      <div className="container mx-auto px-5 md:px-10 py-20 flex flex-col items-center justify-center min-h-[80vh]">
        {/* Main 404 Display */}
        <div className="text-center space-y-8">
          {/* Animated 404 with Wiring Effect */}
          <div className="relative">
            <h1 className="wire-text-glow bg-gradient-to-r from-themeColor1 via-themeColor2 to-themeColor3 text-9xl md:text-[12rem] font-bold text-transparent bg-clip-text">
              404
            </h1>

            {/* Animated Wire Connections */}
            <div className="absolute inset-0 pointer-events-none">
              <div className="wire-line wire-line-1"></div>
              <div className="wire-line wire-line-2"></div>
              <div className="wire-line wire-line-3"></div>
              <div className="wire-line wire-line-4"></div>

              {/* Connection Points */}
              <div className="connection-point connection-point-1">
                <div className="spark spark-1"></div>
              </div>
              <div className="connection-point connection-point-2">
                <div className="spark spark-2"></div>
              </div>
              <div className="connection-point connection-point-3">
                <div className="spark spark-3"></div>
              </div>
            </div>
          </div>

          {/* Error Messages */}
          <div className="space-y-4">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 circuit-flicker">
              Connection Lost!
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Looks like there's a short circuit in our wiring harness! The page
              you're looking for seems to have disconnected from our automotive
              electrical system.
            </p>
          </div>

          {/* Diagnostic Panel */}
          <div className="bg-white/70 backdrop-blur-sm border-2 border-themeColor1/40 rounded-xl p-8 max-w-md mx-auto diagnostic-panel shadow-xl">
            <h3 className="text-themeColor1 font-semibold mb-6 flex items-center gap-3 text-lg">
              <span className="diagnostic-led"></span>
              System Diagnostic
            </h3>
            <div className="space-y-3 text-left">
              <div className="flex justify-between text-sm font-medium">
                <span className="text-gray-600">Power Supply:</span>
                <span className="text-green-500 font-semibold">✓ OK</span>
              </div>
              <div className="flex justify-between text-sm font-medium">
                <span className="text-gray-600">Ground Connection:</span>
                <span className="text-green-500 font-semibold">✓ OK</span>
              </div>
              <div className="flex justify-between text-sm font-medium">
                <span className="text-gray-600">Signal Wire:</span>
                <span className="text-green-500 font-semibold">✓ OK</span>
              </div>
              <div className="flex justify-between text-sm font-medium">
                <span className="text-gray-600">Page Route:</span>
                <span className="text-red-500 route-error font-semibold">
                  ✗ DISCONNECTED
                </span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center pt-8">
            <button
              onClick={() => navigate("/")}
              className="electric-button electric-button-primary"
            >
              <span className="button-spark"></span>
              Reconnect to Home
            </button>

            <button
              onClick={() => navigate(-1)}
              className="electric-button electric-button-secondary"
            >
              Check Previous Connection
            </button>
          </div>

          {/* Fun Automotive Message */}
          <div className="mt-12 p-6 bg-gradient-to-r from-themeColor1/10 to-themeColor3/10 border-l-4 border-themeColor1 rounded-r-xl max-w-lg mx-auto shadow-lg">
            <p className="text-gray-700 text-sm italic font-medium">
              💡 Pro Tip: In automotive wiring, always check your connections
              twice! The same applies to web navigation - double-check that URL!
            </p>
          </div>
        </div>

        {/* Floating Wire Elements */}
        <div className="floating-wires">
          <div className="floating-wire floating-wire-1"></div>
          <div className="floating-wire floating-wire-2"></div>
          <div className="floating-wire floating-wire-3"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
